export default {
  1: 'ACTIVE',
  2: 'SIGNPENDANT',
  3: 'INACTIVE',
  4: 'WAIT',
  5: 'PENDINGVALIDATION',
  6: 'PENDINGREGISTRATION',
  7: 'PENDINGPAYMENT',
  8: 'CANCELLEDCARD',
  9: 'STANDBYWITHOUTPRIZE',
  10: 'PASSWORDSIGNPENDANT',
  52: 'BLOCKEDUSER',
};
